import Image from 'next/image'
import React from 'react'
import type { OnLoadingComplete, PlaceholderValue } from 'next/dist/shared/lib/get-img-props'

type Props = Omit<
  React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>,
  'height' | 'width' | 'loading' | 'ref' | 'alt' | 'src' | 'srcSet' | 'sizes'
> & {
  full?: boolean
  src: string
  alt: string
  width?: number | `${number}`
  height?: number | `${number}`
  // fill?: boolean
  quality?: number | `${number}`
  priority?: boolean
  loading?: 'eager' | 'lazy' | undefined
  placeholder?: PlaceholderValue
  blurDataURL?: string
  unoptimized?: boolean
  overrideSrc?: string
  onLoadingComplete?: OnLoadingComplete
  layout?: string
  objectFit?: string
  objectPosition?: string
  lazyBoundary?: string
  lazyRoot?: string
} & React.RefAttributes<HTMLImageElement | null>

export const ImageFill = ({ loading, full, ...rest }: Props) => {
  return (
    // eslint-disable-next-line jsx-a11y/alt-text
    <Image
      fill
      loading={loading === undefined ? 'lazy' : loading}
      sizes={!full ? '(max-width: 768px) 50vw, 33vw' : '100vw'}
      {...rest}
    />
  )
}
